import React from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

function SongbookQueueDisable(props) {

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onDisable();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_confirm_sb_prequeue_off}</DialogTitle>
      <DialogContent>

      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={props.onDisable}>Ok</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SongbookQueueDisable;